export const APP_API_ROOT_URL = `${process.env.VUE_APP_APP_API_ROOT_URL}`;
export const APP_REDIRECT_URL = `${process.env.VUE_APP_APP_REDIRECT_URL}`;
export const APP_LOGOUT_REDIRECT_URL = `${process.env.VUE_APP_APP_LOGOUT_REDIRECT_URL}`;
export const APP_API_SCOPE = `${process.env.VUE_APP_APP_API_SCOPE}`;
export const APP_AUTHORITY = `${process.env.VUE_APP_APP_AUTHORITY}`;
export const APP_CLIENT_ID = `${process.env.VUE_APP_APP_CLIENT_ID}`;
export const APP_VERSION = `${process.env.VUE_APP_APP_VERSION}`;
export const VUE_APP_IDP_APP_CLIENT_ID = `${process.env.VUE_APP_IDP_APP_CLIENT_ID}`;
export const VUE_APP_IDP_APP_AUTHORITY = `${process.env.VUE_APP_IDP_APP_AUTHORITY}`;
export const VUE_APP_IDP_APP_REDIRECT_URI = `${process.env.VUE_APP_IDP_APP_REDIRECT_URI}`;
export const VUE_APP_IDP_APP_SILENT_REDIRECT_URI = `${process.env.VUE_APP_IDP_APP_SILENT_REDIRECT_URI}`;
export const VUE_APP_IDP_APP_POST_LOGOUT_REDIRECT_URI = `${process.env.VUE_APP_IDP_APP_POST_LOGOUT_REDIRECT_URI}`;
export const VUE_APP_IDP_APP_SCOPE = `${process.env.VUE_APP_IDP_APP_SCOPE}`;
export const VUE_APP_APP_CW_HUB_URL = `${process.env.VUE_APP_APP_CW_HUB_URL}`;
export const VUE_APP_APP_NC_HUB_URL = `${process.env.VUE_APP_APP_NC_HUB_URL}`;
export const VUE_APP_APP_GC_HUB_URL = `${process.env.VUE_APP_APP_GC_HUB_URL}`;
export const VUE_APP_APP_EXTERNAL_INTEGRATION_HUB_URL = `${process.env.VUE_APP_APP_EXTERNAL_INTEGRATION_HUB_URL}`;
